﻿<template>
    <Dialog v-model:visible="isVisible" modal :header="$t('themeStyle.title')"
            :style="{ width: '40vw' }"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            @hide="onHide">
        <div class="theme-row">
            <label for="fontSize" class="theme-label">{{$t('themeStyle.fontSize')}}</label>
            <SelectButton id="fontSize" v-model="styling.fontSize" :options="fontSizeOpt" aria-labelledby="basic" />
        </div>
        <div class="theme-row">
            <label for="inputStyle" class="theme-label">{{$t('themeStyle.inputStyle')}}</label>
            <SelectButton id="inputStyle" v-model="styling.inputStyle" :options="inputStyleOpt" aria-labelledby="basic" />
        </div>
        <div class="theme-row">
            <label for="ripple" class="theme-label">{{$t('themeStyle.ripple')}}</label>
            <ToggleSwitch id="ripple" v-model="styling.ripple" v-tooltip="$t('themeStyle.rippleTooltip')" />
        </div>
        <div class="theme-row">
            <label for="theme" class="theme-label">{{$t('themeStyle.theme')}}</label>
            <SelectButton v-model="styling.theme" :options="themeOpt" aria-labelledby="basic" />
        </div>
    </Dialog>
</template>

<style scoped>
    /* 設定列：桌面橫排（label 固定寬 + 選項並排）；窄螢幕（手機）改直排（label 在上、選項在下），
       避免 Dialog 變窄時 label 與 SelectButton 互相擠壓。 */
    .theme-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.75rem;
        margin-bottom: 1.25rem;
    }

    .theme-label {
        font-weight: 600;
        width: 6rem;
        flex-shrink: 0;
    }

    /* 手機（直立，約 ≤ 640px）：改直排，label 置上不佔寬，選項在下方完整顯示。 */
    @media (max-width: 640px) {
        .theme-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.5rem;
        }

        .theme-label {
            width: auto;
        }
    }
</style>

<script lang="ts">
    //normal <script> executed in module scope (only once)
    //只會執行一次(第1次) 除非按下F5

    export default {
        name: module$.themeStyle,
        inheritAttrs: false
    }
</script>

<script setup lang="ts">
    import { ref, watchEffect, watch, onUnmounted } from 'vue'
    import { utilfcty$ } from '../utils/utility'
    import { useI18n } from 'vue-i18n'
    import { module$ } from '../enums'
    import { storeToRefs } from 'pinia'

    const props = defineProps({
        visible: { type: Boolean, required: true, default: false }
    })

    const emit = defineEmits(['update:visible']);

    //***************工具物件***************
    const util$ = utilfcty$.vueUse();
    const appStore = util$.pinia$.app;
    //locales/{locales}/themeStyle.json
    const { t, tm } = useI18n(); // 取得翻譯函式 t
    const { styling } = storeToRefs(appStore);
    const inputStyleOpt = ref(['filled', 'outlined']);
    const fontSizeOpt = ref(tm('themeStyle.fontSizeOpts'));
    const themeOpt = ref(['light', 'dark'])


    //***************屬性/計算**************
    const isVisible = ref(props.visible);
    const isModified = ref(false);

    //***************元件函式**************
    const onHide = () => {
        isVisible.value = false;
        emit('update:visible', false);
    }
    //***************元件監看**************
    watchEffect(() => {
        isVisible.value = props.visible;
    });

    watch(styling, (newValue: any, oldValue: any) => {
        //styling值改變時套用設定
        util$.log$.info(newValue);
        util$.pinia$.app.applyStyling();
        isModified.value = true;
    }, { deep: true })

    //***************元件鉤子**************
    onUnmounted(() => {
        if (isModified.value) {
            util$.pinia$.app.refreshPage();
        }
    })

</script>